import {
  Button as MuiButton,
  Box,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";
import { Email as EmailIcon } from "@mui/icons-material";
import { ExpiredToken } from "@/assets";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

function ResendCode({ onClick }: { onClick: () => void }) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 3,
        py: 2,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: "text.primary",
          mb: 1,
        }}
      >
        {t("comfirm.title")}!
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          maxWidth: 300,
          lineHeight: 1.6,
        }}
      >
        {t("comfirm.sendCode")}
      </Typography>

      <Box
        component="img"
        src={ExpiredToken}
        alt="expired token"
        sx={{
          width: 200,
          height: "auto",
          my: 3,
        }}
      />

      <MuiButton
        variant="contained"
        size="large"
        onClick={onClick}
        startIcon={<EmailIcon />}
        sx={{
          py: 1.5,
          px: 4,
          borderRadius: 2,
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 600,
          background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
          boxShadow: `0 4px 14px 0 ${alpha(theme.palette.primary.main, 0.4)}`,
          "&:hover": {
            background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
            boxShadow: `0 6px 20px 0 ${alpha(theme.palette.primary.main, 0.6)}`,
            transform: "translateY(-1px)",
          },
          transition: "all 0.2s ease-in-out",
        }}
      >
        {t("comfirm.resendCode")}
      </MuiButton>
    </Box>
  );
}

export default ResendCode;
